module.exports = __webpack_public_path__ + "assets/b823f3440dd0ff3690e7f4976047602f.png";